import { siteConfig } from "./site-config";

export const siteUrl = siteConfig.brand.siteUrl;
export const siteName = siteConfig.brand.name;

type PageMetadata = {
  title: string;
  description: string;
  path: string;
  keywords: string[];
  image?: string;
  noIndex?: boolean;
};

export function createMetadata({
  title,
  description,
  path,
  keywords,
  image = "/assets/earth.jpg",
  noIndex = false,
}: PageMetadata) {
  const socialTitle =
    path === "/" ? `${siteName}｜${title}` : `${title}｜${siteName}`;

  return {
    title: path === "/" ? { absolute: socialTitle } : title,
    description,
    keywords,
    alternates: { canonical: path },
    openGraph: {
      type: "website",
      locale: "zh_CN",
      url: path,
      siteName,
      title: socialTitle,
      description,
      images: [{ url: image, alt: socialTitle }],
    },
    twitter: {
      card: "summary_large_image",
      title: socialTitle,
      description,
      images: [image],
    },
    robots: noIndex
      ? { index: false, follow: false, noarchive: true }
      : { index: true, follow: true },
  };
}

export function serializeJsonLd(value: object) {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}
